import { useEffect, useState } from 'react';
import type { ZXCVBNScore } from 'zxcvbn';

// Saved to const, so it can be lazy loaded when required
const loadPasswordCheck = () => import('zxcvbn');

export const useStrengthScore = (isValid: boolean, password: string): ZXCVBNScore => {
	const [score, setScore] = useState<ZXCVBNScore>(0);

	useEffect(() => {
		if (!isValid || !password) {
			setScore(0);
			return;
		}

		let cancelled = false;

		void loadPasswordCheck().then(({ default: zxcvbn }) => {
			if (!cancelled) {
				setScore(zxcvbn(password).score);
			}
		});

		return () => {
			cancelled = true;
		};
	}, [isValid, password]);

	return score;
};
